import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
	logo: {
		maxWidth: 400,
		width: 'auto',
		marginBottom: 50,

		[theme.breakpoints.down('sm')]: {
			maxHeight: 41,
		},
	},
	headerActions: {
		display: 'flex',
		flexWrap: 'nowrap',
		textAlign: 'end',
		[theme.breakpoints.down('sm')]: {
			textAlign: 'start',
		},
	},
	logoContainer: {
		textAlign: 'center',
		[theme.breakpoints.down('sm')]: {
			textAlign: 'end',
		},
	},
}));
